import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect } from 'react'
import {
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
  $insertNodes,
} from 'lexical'
import { ImageNode } from '../nodes/ImageNode'
import { cloudinaryService } from '../../../services/cloudinary.service'
import { useSelector } from 'react-redux'

export function DragDropUploadPlugin() {
  const [editor] = useLexicalComposerContext()
  const loggedInUser = useSelector((state) => state.userModule.loggedInUser)

  useEffect(() => {
    const handleDrop = async (e) => {
      e.preventDefault()
      const file = e.dataTransfer?.files?.[0]
      if (!file?.type.startsWith('image/')) return

      try {
        /* העלאה ל־Cloudinary דרך ה־backend */
        const { imgUrl } = await cloudinaryService.uploadImage(file, {
          type: 'post-img',
          relatedId: loggedInUser?._id || 'anonymous',
        })

        /* הוספת ImageNode לעורך */
        editor.update(() => {
          const selection = $getSelection()
          const imageNode = new ImageNode(imgUrl, file.name)

          if ($isRangeSelection(selection)) {
            selection.insertNodes([imageNode])
          } else {
            const paragraph = $createParagraphNode()
            paragraph.append(imageNode)
            $insertNodes([paragraph])
          }
        })
      } catch (err) {
        console.error('❌ העלאת תמונה נכשלה:', err)
      }
    }

    const editorElem = editor.getRootElement()
    if (!editorElem) return

    const prevent = (e) => e.preventDefault()
    editorElem.addEventListener('dragover', prevent)
    editorElem.addEventListener('drop', handleDrop)

    return () => {
      editorElem.removeEventListener('dragover', prevent)
      editorElem.removeEventListener('drop', handleDrop)
    }
  }, [editor, loggedInUser])

  return null
}
